// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/magnifying-glass.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'magnifying-glass',
  version: 'outline',
  paths: [
    {
      d: 'm21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z',
    },
  ],
}
